import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { Form } from '@unform/web';
import * as Yup from 'yup';
import CircularProgress from '@material-ui/core/CircularProgress';
import DatePicker from '~/styles/components/DatePicker';
import SimpleButton from '~/styles/components/SimpleButton';
import Backdrop from '~/components/BackdropComponent';
import { errorMessage } from '~/utils/Message';

import { download } from '~/services/xlsx';
import api from '~/services/api';

import { Container, Content } from './styles';
import { SubTitle } from '../../styles';

function Emergency() {
  const profile = useSelector((state) => state.user.profile);
  const hemocenter_id = profile.hemocenter ? profile.hemocenter.id : undefined;

  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = 'Relatório de emergências | ClickHemofilia';
  }, []);

  async function handleSubmit(data) {
    setLoading(true);

    try {
      const schema = Yup.object({
        startDate: Yup.string().required('Campo obrigatório.').nullable(),
        endDate: Yup.string().required('Campo obrigatório.').nullable(),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      const { startDate, endDate } = data;

      const response = await api.get('/report/emergencies', {
        params: {
          hemocenter_id,
          startDate,
          endDate,
        },
        responseType: 'blob',
      });

      download(response.data);
    } catch (error) {
      const validationErrors = {};
      if (error instanceof Yup.ValidationError) {
        error.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      } else if (error.response.status === 400) {
        errorMessage('There were no records in this time interval');
      } else {
        errorMessage(error);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container>
      <SubTitle>Emitir relatório de Emergências em arquivo Excel</SubTitle>

      <Form onSubmit={handleSubmit} ref={formRef}>
        <Content>
          <DatePicker
            label="Data de início"
            name="startDate"
            placeholder="dd/mm/yyyy"
          />
          <DatePicker
            label="Data de término"
            name="endDate"
            placeholder="dd/mm/yyyy"
          />
        </Content>

        <SimpleButton type="submit">Gerar relatório</SimpleButton>
      </Form>

      <Backdrop open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
}

export default Emergency;
